import { setup } from './core/src/setup';
import config from './config/config.js';

// import './core/node_modules/vue-material/dist/theme/default-dark.css';
import './core/node_modules/vue-material/dist/theme/default.css';
import './config/override.sass';

setup(config, require('./package').versions);
